import { useCallback } from 'react'
import { ButtonPrimary, ButtonRed, ButtonSecondary } from '../../../../../../../baseComponents/Button'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { TPVOrderData } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import ModalMoneyCashInOut from './ModalMoneyCashInOut'
import ModalConfirmMoneyCashInOut from './ModalConfirmMoneyCashInOut'
import ModalCashRegisterMoneyLogs from './ModalCashRegisterMoneyLogs'
import ModalPaymentTypesRegister from './ModalPaymentTypesRegister'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { PaymentTypesPayload } from '../../../../../../../utils/reducers/payments/paymentTypes'
import '../SCDashboardTPV.sass'


interface MoneyCashInOutTPVDSBProps extends MoneyCashInOutTPVDSBLogicProps { 
    title: string
}

const MoneyCashInOutTPVDSB: React.FC<MoneyCashInOutTPVDSBProps> = ({ title, ...rest }) => {
    const { handleOpenMoneyCashInOutModal, openModal, setOpenModal } = useMoneyCashInOutTPVDSBLogic({ ...rest })
    
    return (
         <div className='flex flex-auto flex-col overflow-hidden dashboad_cash_in_out'>
            <h3 className='pb-15'>{title}</h3>
            <div className='flex flex-col flex-auto gap-y-20'>
                <ButtonPrimary onClick={() => handleOpenMoneyCashInOutModal('cashIn')}><TwinTrans transKey='cashIn'>Entrada de caja</TwinTrans></ButtonPrimary>
                <ButtonRed onClick={() => handleOpenMoneyCashInOutModal('cashOut')}><TwinTrans transKey='cashOut'>Salida de caja</TwinTrans></ButtonRed>
                <ButtonSecondary onClick={() => setOpenModal({ type: 'delete', allRowData: { type: 'cashRegisterLogs', CashRegisterId: rest.completeData?.cashRegister?.id } })}><TwinTrans transKey='cashRegisterLogs'>Registro de caja</TwinTrans></ButtonSecondary>
                <ButtonSecondary onClick={() => setOpenModal({ type: 'delete', allRowData: { type: 'paymentTypesRegister', CashRegisterId: rest.completeData?.cashRegister?.id } })}><TwinTrans transKey='paymentMethodsRegister'>Registro de métodos de pago</TwinTrans></ButtonSecondary>
            </div>
            {openModal?.type === 'edit' ? <ModalMoneyCashInOut setOpenModal={setOpenModal} allRowData={openModal?.allRowData}/> : null}
            {openModal?.type === 'create' ? <ModalConfirmMoneyCashInOut allRowData={openModal?.allRowData} setOpened={() => setOpenModal(null)} onSubmit={() => setOpenModal(null)} url={'/api/app/order/tpv/cashRegister/cashRegisterMoney/handleCashRegisterMoneyAndLogs'} /> : null}
            {openModal?.type === 'delete' && openModal?.allRowData?.type === 'cashRegisterLogs' ? <ModalCashRegisterMoneyLogs setOpenModal={setOpenModal} allRowData={openModal?.allRowData}/> : null}
            {openModal?.type === 'delete' && openModal?.allRowData?.type === 'paymentTypesRegister' ? <ModalPaymentTypesRegister setOpenModal={setOpenModal} allRowData={openModal?.allRowData}/> : null}
        </div>
    )
}

interface MoneyCashInOutTPVDSBLogicProps {
    completeData: TPVOrderData | null
}

const useMoneyCashInOutTPVDSBLogic = ({ completeData }: MoneyCashInOutTPVDSBLogicProps) => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    const handleOpenMoneyCashInOutModal = useCallback((action: 'cashIn' | 'cashOut') => {
        setOpenModal({ type: 'edit', allRowData: { action, CashRegisterId: completeData?.cashRegister?.id } })
    }, [setOpenModal, completeData?.cashRegister?.id])
    return { handleOpenMoneyCashInOutModal, openModal, setOpenModal }
}


const paymentTypesDispatch = {
    setPaymentTypes: (payload: PaymentTypesPayload) => ({ type: 'CHANGE_PAYMENTTYPES', payload }),
}

export type ReduxPaymentTypes = ConnectedProps<typeof PaymentTypesConnect>
const mapPaymentTypesConnector = (state: AllReduxPayloads) => ({ paymentTypes: state.paymentTypes })
const PaymentTypesConnect = connect(mapPaymentTypesConnector, paymentTypesDispatch)
const PaymentTypesConnectLoading = withLoading(MoneyCashInOutTPVDSB, [{ fetchUrl: '/api/app/config/payment/paymentType/getAllPaymentTypes', propName: 'paymentTypes', setFunctionName: 'setPaymentTypes' }])
const MoneyCashInOutTPVDSBConnect = PaymentTypesConnect(PaymentTypesConnectLoading)

export default MoneyCashInOutTPVDSBConnect
